import request from '../services/request';

export function search(data) {
  return request({
    url: `/registry/search`,
    method: 'POST',
    data,
  });
}

export function searchRegisters(data, page) {
  return request({
    url: `/registry/search?page=${page}`,
    method: 'POST',
    data,
  });
}

export function indexRegistry() {
  return request({
    url: `/registry`,
    method: 'GET',
  });
}

export function getRegistryById(id, data) {
  return request({
    url: `/registry/${id}`,
    method: 'GET',
    data,
  });
}

export function storeRegistry(data) {
  return request({
    url: `/registry`,
    method: 'POST',
    data,
  });
}

export function updateRegistry(id, data) {
  return request({
    url: `/registry/${id}`,
    method: 'PUT',
    data,
  });
}

export function deleteRegistry(id) {
  return request({
    url: `/registry/${id}`,
    method: 'DELETE',
  });
}

export function statusRegistry(id, data) {
  return request({
    url: `/registry/${id}/status`,
    method: 'PUT',
    data,
  });
}

export function exportFile(data, configs) {
  return request({
    url: `/registry/export`,
    method: 'POST',
    responseType: 'blob',
    data,
    ...configs,
  });
}

export function getAnalyticsRegistry(data) {
  return request({
    url: `/registry/dashboard/analytics`,
    method: 'POST',
    data,
  });
}

// -------------- Catalogos para combobox ------------------------
export function catalogCompanies() {
  return request({
    url: `/registry/catalog/companies`,
    method: 'GET',
  });
}

export function catalogLocations(data) {
  return request({
    url: `/registry/catalog/locations`,
    method: 'POST',
    data,
  });
}

export function catalogBuildings(data) {
  return request({
    url: `/registry/catalog/building`,
    method: 'POST',
    data,
  });
}

export function catalogZones(data) {
  return request({
    url: `/registry/catalog/zone`,
    method: 'POST',
    data,
  });
}

export function resetRegistry(id) {
  return request({
    url: `/registry/${id}/reset`,
    method: 'PUT',
  });
}
